module.exports = __webpack_public_path__ + "components/carousel-nearby-mountains/static/icon-caret-left-a3e1fad94bf5c8abc4f3ac793610bb6c.svg";